/**
 * Cruza la lista fija de logos con las marcas que el catalogo tiene publicadas.
 */
import { LOGOS_MARCAS, type LogoMarca } from '../configuracion/logos-marcas';

export interface LogoVigente extends LogoMarca {
  /** La marca tal como la escribe el catalogo: es lo que se busca al hacer clic. */
  termino: string;
}

/** "Häfele" y "HAFELE", "Porter-Cable" y "PORTER CABLE" quedan iguales. */
function normalizarMarca(marca: string): string {
  return marca
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

/** Superficie que ocupa cada logo en la cinta, en px². */
const AREA_EN_CINTA = 7800;
const ALTO_MAXIMO_EN_CINTA = 64;
const ANCHO_MAXIMO_EN_CINTA = 200;

/**
 * Medida con que se dibuja un logo en la cinta. Se iguala la superficie y no
 * el alto: a igual alto, un logo apaisado (Porter-Cable) queda enorme al lado
 * de uno cuadrado (Klingspor), y a igual ancho, al reves.
 */
export function medidaEnCinta(logo: LogoMarca): { ancho: number; alto: number } {
  const proporcion = logo.ancho / logo.alto;
  let alto = Math.min(Math.sqrt(AREA_EN_CINTA / proporcion), ALTO_MAXIMO_EN_CINTA);
  let ancho = alto * proporcion;
  if (ancho > ANCHO_MAXIMO_EN_CINTA) {
    ancho = ANCHO_MAXIMO_EN_CINTA;
    alto = ancho / proporcion;
  }
  return { ancho: Math.round(ancho), alto: Math.round(alto) };
}

export function logosVigentes(marcasPublicadas: string[]): LogoVigente[] {
  const porNombre = new Map(marcasPublicadas.map((marca) => [normalizarMarca(marca), marca]));

  return LOGOS_MARCAS.flatMap((logo) => {
    const termino = logo.nombres
      .map((nombre) => porNombre.get(normalizarMarca(nombre)))
      .find((marca) => marca !== undefined);
    return termino === undefined ? [] : [{ ...logo, termino }];
  });
}
